import { render, staticRenderFns } from "./AutEquipeCirurgia.vue?vue&type=template&id=7de5912a&"
import script from "./AutEquipeCirurgia.vue?vue&type=script&lang=js&"
export * from "./AutEquipeCirurgia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports